<div [ngClass]="{'round':!small, 'round-small':small}">
    <input type="checkbox" 
                [(ngModel)]="checked" 
                [disabled]="disabled" 
                [id]="id" 
                name="rounded-chk"  
                (blur)="onBlur($event)"
                (ngModelChange)="onModelChange($event)"
                />
    <label [for]="id"></label>
</div>